"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var ObjectId = require('bson').ObjectID;
var clone = require('clone');
var tv4 = require('tv4');
var GroupReference = require('../core/group-reference');
var InventoryReference = require('./inventory-reference');
var PersonReference = require('../core/person-reference');
var Inventory = /*#__PURE__*/function () {
  function Inventory(opt) {
    _classCallCheck(this, Inventory);
    this._id = new ObjectId();
    this.tenantCode = null;
    this.campusCode = null;
    this.colleagues = [];
    this.groups = [];
    this.name = null;
    this.owner = null;
    this.tags = [];
    this.permissions = [];
    this.lastCertifiedBy = null;
    this.lastCertifiedDate = null;
    this.stockroom = false;
    this.orgCodes = [];
    if (opt) {
      this.fillObject(clone(opt));
    }
  }
  _createClass(Inventory, [{
    key: "fillObject",
    value: function fillObject(opt) {
      this._id = new ObjectId(opt._id);
      // eslint-disable-next-line no-underscore-dangle
      this._createdDate = this._id.getTimestamp();
      this.tenantCode = opt.tenantCode || opt.owner.tenantCode;
      this.campusCode = opt.campusCode || opt.owner.campusCode;
      this.name = opt.name;
      this.colleagues = Array.isArray(opt.colleagues) ? opt.colleagues.map(function (colleague) {
        return new InventoryReference(colleague);
      }) : [];
      this.owner = new PersonReference(opt.owner);
      this.groups = Array.isArray(opt.groups) ? opt.groups.map(function (group) {
        return new GroupReference(group);
      }) : [];
      this.tags = Array.isArray(opt.tags) ? _toConsumableArray(opt.tags) : [];
      this.permissions = Array.isArray(opt.permissions) ? _toConsumableArray(opt.permissions) : [];
      this.lastCertifiedBy = opt.lastCertifiedBy ? new PersonReference(opt.lastCertifiedBy) : null;
      this.lastCertifiedDate = opt.lastCertifiedDate ? new Date(opt.lastCertifiedDate) : null;
      this.stockroom = !!opt.stockroom;
      this.orgCodes = opt.orgCodes || [];
    }
  }, {
    key: "validate",
    value: function validate() {
      return tv4.validateMultiple(this, Inventory.schema());
    }
  }], [{
    key: "schema",
    value: function schema() {
      return {
        $schema: 'http://json-schema.org/draft-04/schema#',
        id: 'inventory.schema.json',
        type: 'object',
        properties: {
          _id: {
            type: 'object'
          },
          tenantCode: {
            type: 'string'
          },
          campusCode: {
            type: 'string'
          },
          colleagues: {
            type: 'array',
            item: {
              $ref: 'inventory-reference.schema.json'
            }
          },
          groups: {
            type: 'array',
            item: {
              $ref: 'group-reference.schema.json'
            }
          },
          name: {
            type: 'string'
          },
          owner: {
            $ref: 'person-reference.schema.json'
          },
          tags: {
            type: 'array',
            item: {
              type: 'string'
            }
          },
          permissions: {
            type: 'array',
            item: {
              type: 'object'
            }
          },
          lastCertifiedBy: {
            anyOf: [{
              $ref: 'person-reference.schema.json'
            }, {
              type: ['null']
            }]
          },
          lastCertifiedDate: {
            type: ['object', 'null']
          },
          stockroom: {
            type: 'boolean'
          },
          orgCodes: {
            type: 'array',
            item: {
              type: 'string'
            }
          }
        },
        required: Object.keys(new Inventory())
      };
    }
  }]);
  return Inventory;
}();
tv4.addSchema(GroupReference.schema());
tv4.addSchema(InventoryReference.schema());
tv4.addSchema(PersonReference.schema());
module.exports = Inventory;